module.exports = __webpack_public_path__ + "img/logo-onyxerp.9f2465d4.png";